import React, { useState, useMemo, Suspense } from 'react';
import './Photos.css';

const EnlargedImage = React.lazy(() => import('./EnlargedImage'));

const PhotoItem = React.memo(({ src, alt, onClick }) => {
  return (
    <div className="photo-item">
      <img
        src={src}
        alt={alt}
        className="photo-img"
        loading="lazy"
        onClick={onClick}
      />
    </div>
  );
});

function OtherEventsPage() {
  const totalImages = 24;
  const [viewAll, setViewAll] = useState(false);
  const [enlargedImage, setEnlargedImage] = useState(null);

  const visibleCount = viewAll ? totalImages : 6;

  const handleClose = () => setEnlargedImage(null);
  const handleImageClick = (image) => setEnlargedImage(image);

  const loadImage = (index) => `/images/other_events/${index + 1}.jpg`;

  const visibleImages = useMemo(() => {
    return Array.from({ length: visibleCount }, (_, index) => ({
      src: loadImage(index),
      alt: `Event ${index + 1}`,
    }));
  }, [visibleCount]);

  return (
    <div className="photos-container">
      <h2 className="photos-heading">OTHER EVENTS</h2>

      {enlargedImage && (
        <Suspense fallback={<div className="loading-overlay">Loading...</div>}>
          <EnlargedImage image={enlargedImage} onClose={handleClose} />
        </Suspense>
      )}

      <div className="photos-grid">
        {visibleImages.map((image, index) => (
          <PhotoItem
            key={index}
            src={image.src}
            alt={image.alt}
            onClick={() => handleImageClick(image.src)}
          />
        ))}
      </div>

      {!viewAll && totalImages > 6 && (
        <div className="view-all-btn-wrapper">
          <button className="view-all-btn" onClick={() => setViewAll(true)}>
            View All
          </button>
        </div>
      )}
    </div>
  );
}

export default OtherEventsPage;
